const initParams = (query) => {
  const {
    start,
    end,
    target
  } = query
  const params = {}
  if (start && end) {
    params.procStartDateTime = [`${start}`, `${end}`]
  }
  if (target) {
    let val = ''
    switch (target) {
      case 'successPass':
        val = 'success_end'
        break
      case 'failedPass':
        val = 'fail_end'
        break
      case 'termination':
        val = 'termination'
        break
    }
    params.completeStatus = val
  }
  return params
}

const initFixedCondition = (query, params) => {
  const {
    start,
    end,
    target
  } = query
  const conds = []
  if (start && end) {
    conds.push({
      type: 'procStartDateTime',
      rangeSeachArray: params.procStartDateTime
    })
  }
  if (target) {
    conds.push({
      type: 'completeStatus',
      secondType: params.completeStatus
    })
  }
  return conds
}

export {
  initParams,
  initFixedCondition
}
